import { makeStyles, withStyles } from "@material-ui/core/styles";
import { TableCell, TableRow } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    tableRoot: {
        width: "100%",
        marginTop: theme.spacing(1),
    },
    tableContainer: {
        maxHeight: "70vh",
        borderRadius: 5,
    },
    modalTableRoot: {
        width: "100%",
    },
    modalTableContainer: {
        maxHeight: "70vh",
    },
    weekSelectorContainer: {
        color: theme.palette.common.white,
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
    },
    weekSelectorContent: {
        color: "black",
    },
    tableHead: {
        backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.common.white,
    },
    positiveBtn: {
        margin: theme.spacing(1),
        color: "white",
        backgroundColor: theme.palette.primary.dark,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
    negativeBtn: {
        margin: theme.spacing(1),
        color: "white",
        background: theme.palette.secondary.dark,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    arrowIcons: {
        color: theme.palette.primary.main,
    },
    dialogTitleContainer: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.dark,
        borderBottom: "solid",
    },
    dialogTitle: {
        fontWeight: "bold",
    },
    noDataMessage: {
        display: "flex",
        justifyContent: "center",
    },
}));

export const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export const StyledTableRow = withStyles(theme => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default,
        },
    },
}))(TableRow);
